<div class="row mb-3">
  <section class="col-md-12">
    <div class="mb-3 mt-2 position-relative">
      <i-title [text]="'reporting.title' | translate" level="1"></i-title>
    </div>
    <div class="col-md-12 d-flex justify-content-between align-items-center">
      <div></div>
      <i-tabs class="box" [items]="tabsArray" (tabChange)="receive_tabs($event)" [align]="'center'"> </i-tabs>
      <div class="d-flex align-items-center justify-content-center">
        <i-button
          [text]="'advancedSearch.advancedSearch' | translate"
          id="adevancedSearchReporting"
          styleClass="blue"
          (click)="openSearchModal()"
          [count]="paramsCount ? paramsCount : 0"></i-button>
        <i class="bi bi-x-circle-fill ms-3" (click)="reset(true)" [pTooltip]="'advancedSearch.reset' | translate"></i>
      </div>
    </div>
  </section>
</div>
<section class="row">
  <div class="col-md-12">
    @if (files.length > 0) {
      <i-table
        (onClickRow)="showDialog($event)"
        [height]="'calc(100vh - 200px)'"
        [paginator]="true"
        class="super-table"
        [columns]="columnTable"
        [items]="files | sort: 'id' : 'DESC'"
        [id]="idTable"
        [multiselect]="true"
        [search]="true"
        [enableConfirmColumn]="true">
      </i-table>
    }
    @if (files.length === 0) {
      <div class="col-md-12 d-flex align-items-center justify-content-center mt-4">
        <img class="img-fluid" src="./assets/img/decoration/nofiles.svg" width="400" alt="" />
      </div>
    }
  </div>
</section>

<p-dialog styleClass="super-compos-modal-content modal-scss" [(visible)]="openAdvancedSearchModal" [modal]="true" [closable]="true" appendTo="body">
  <p-header>
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="modal-title personalized-modal-title-iCourrier">{{ 'advancedSearch.advancedSearch' | translate }}</h5>
      <div class="d-flex align-items-center">
        <i-button styleClass="blue me-3" (click)="filter()" [text]="'search' | translate"></i-button>
        <i-button styleClass="red me-3" (click)="reset()" [text]="'reset' | translate"></i-button>
      </div>
    </div>
  </p-header>
  <div class="row mb-3">
    <div class="col-md-12 p-fluid mb-3">
      <label class="super-compos-label-input">{{ 'service' | translate }}</label>
      <p-treeSelect
        #treeSelect
        selectionMode="single"
        [options]="serviceParent"
        (onShow)="onShowTreeSelect()"
        [placeholder]="'pleaseSelectAService' | translate"
        appendTo="body"
        (onNodeSelect)="select($event)"
        [emptyMessage]="'noResultFound' | translate"
        [filter]="true"
        [filterPlaceholder]="'global.filterPlaceholder' | translate"
        [filterBy]="'label'"
        [filterMode]="'strict'"
        [metaKeySelection]="false">
      </p-treeSelect>
    </div>
    <div class="col-md-6 mb-3 p-fluid">
      <label class="super-compos-label-input">{{ 'reporting.fileUploadStartDate' | translate }}</label>
      <p-calendar
        [firstDayOfWeek]="1"
        appendTo="body"
        formControlName="dateEntree"
        [showIcon]="true"
        [iconDisplay]="'input'"
        dateFormat="dd/mm/yy"
        [(ngModel)]="params.DtUploadMin"
        [placeholder]="'reporting.fileUploadStartDate' | translate">
      </p-calendar>
    </div>
    <div class="col-md-6 p-fluid mb-3">
      <label class="super-compos-label-input">{{ 'reporting.fileUploadEndDate' | translate }}</label>
      <p-calendar
        [firstDayOfWeek]="1"
        appendTo="body"
        formControlName="dateEntree"
        [showIcon]="true"
        [iconDisplay]="'input'"
        dateFormat="dd/mm/yy"
        [(ngModel)]="params.DtUploadMax"
        [placeholder]="'reporting.fileUploadEndDate' | translate">
      </p-calendar>
    </div>
    <div class="col-md-6">
      <label class="super-compos-label-input">{{ 'chooseAValidationStatus' | translate }}</label>
      <p-dropdown
        styleClass="w-100"
        [virtualScroll]="true"
        virtualScrollItemSize="30"
        appendTo="body"
        [options]="statusValidation"
        [filter]="true"
        [placeholder]="'chooseAValidationStatus' | translate"
        [showClear]="true"
        [(ngModel)]="params.StatusValidation">
        <ng-template let-item pTemplate="selectedItem"
          ><span [ngStyle]="{ color: '#24344b' }">{{ item?.label }}</span></ng-template
        >
      </p-dropdown>
    </div>
    <div class="col-md-6 mb-3">
      <label class="super-compos-label-input">{{ 'chooseASignatureStatus' | translate }}</label>
      <p-dropdown
        styleClass="w-100"
        [virtualScroll]="true"
        itemSize="30"
        appendTo="body"
        [options]="statusSignature"
        [filter]="true"
        [placeholder]="'chooseASignatureStatus' | translate"
        [showClear]="true"
        [(ngModel)]="params.StatusSignature">
        <ng-template let-item pTemplate="selectedItem"
          ><span [ngStyle]="{ color: '#24344b' }">{{ item?.label }}</span></ng-template
        >
      </p-dropdown>
    </div>
  </div>
</p-dialog>
